import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { Grid, Menu, Segment } from 'semantic-ui-react';
import './index.scss'
import { USER_PERMISSIONS, PRODUCT_PERMISSIONS } from 'dyl-components';
import RestrictedView from 'shared/RestrictedView';

const ROUTES = {
    dylNumbers: 'dyl-numbers',
    externalNumbers: 'external-numbers'
}

const Numbers = () => {
    return <Grid>
        <Grid.Row style={{ paddingTop: 0, paddingBottom: 0 }}>
            <Grid.Column style={{ paddingTop: '1em', paddingRight: 0, paddingLeft: '0.5em' }}>
                <Menu secondary className='PhoneManagement_generalTabs'>
                    <RestrictedView type='disabled' userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_VIEW} productPermission={`${PRODUCT_PERMISSIONS.SETTINGS_PHONE_MANAGEMENT}numbers/${ROUTES.dylNumbers}`}>
                        <Menu.Item name='DYL Numbers' as={NavLink} to={ROUTES.dylNumbers} />
                    </RestrictedView>
                    <RestrictedView type='disabled' userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_VIEW} >
                        <Menu.Item name='External Numbers' as={NavLink} to={ROUTES.externalNumbers} />
                    </RestrictedView>
                </Menu>
                <Segment basic className='PhoneManagementNumbers'>
                    <Outlet />
                </Segment>
            </Grid.Column>
        </Grid.Row>
    </Grid>;
}

export default Numbers;
